if ( typeof NutritionalInfo !== 'function' ) {

  class NutritionalInfo extends HTMLElement {
    constructor() {
      super();
      this.currentUnit = '30g';
      this.tableData = [];
      this.renderTable();
      this.setupToggle();
    }

    renderTable(unit = '30g') {
      this.currentUnit = unit;
      let contentDOM = ``;
      let content = this.innerHTML;
      let titleFlag = false;
      content = content.replace(/<\/p>|<\/div>/g, '');
      content = content.split('<p>');
      
      // Store table data for switching
      if (this.tableData.length === 0) {
        for ( let i = 1; i < content.length; i++ ) {
          let contentArray = content[i].split(/<br>|<br\/>|\n/g);
          let tableRows = [];
          
          for ( let j = 0; j < contentArray.length; j++ ) {
            if (contentArray[j].length > 0 && contentArray[j].replace(/\s/g, '').length != 0 ) {
              // Split by comma first, then by pipe for 30g|100g values
              let contentBlockArrayPrepare = contentArray[j].replace(',', '#SD*@N!SA')
              let contentBlockArray = contentBlockArrayPrepare.split('#SD*@N!SA');
              
              if (contentBlockArray.length >= 2) {
                // Split the value part by pipe to get 30g and 100g
                let values = contentBlockArray[1].split('|');
                let value30g = values[0] || '';
                let value100g = values[1] || '';
                
                tableRows.push({
                  title: contentBlockArray[0].replace('- ', ''),
                  value30g: value30g.trim(),
                  value100g: value100g.trim(),
                  isIndent: contentArray[j].includes('- ')
                });
              } else {
                // Fallback for old format
                tableRows.push({
                  title: contentBlockArray[0].replace('- ', ''),
                  value30g: contentBlockArray[1] || '',
                  value100g: '',
                  isIndent: contentArray[j].includes('- ')
                });
              }
            }
          }
          
          this.tableData.push(tableRows);
        }
      }

      // Render table with current unit
      for ( let i = 0; i < this.tableData.length; i++ ) {
        let tableRows = this.tableData[i];
        contentDOM += `<div class="table">`

        if ( this.dataset.titleLabelLeft != '' || this.dataset.titleLabelRight != '' ) {
          if ( !titleFlag ) {
            titleFlag = true;
            contentDOM += `<span class="table-line table-line--heading">`;
            if ( this.dataset.titleLabelLeft != '' ) {
              contentDOM += `<span>${this.dataset.titleLabelLeft}</span>`;
            }
            console.log(this.dataset.titleLabelRight);
            console.log(this.dataset.measuringUnitTitle);
            
            let unitLabel = unit === '30g' ? this.dataset.titleLabelRight : this.dataset.measuringUnitTitle;
            if ( unitLabel != '' ) {
              contentDOM += `<span>${unitLabel}</span>`;
            }
            contentDOM += `</span>`;
          }
        }

        for ( let j = 0; j < tableRows.length; j++ ) {
          let row = tableRows[j];
          let value = unit === '30g' ? row.value30g : row.value100g;
          
          contentDOM += `<span class="table-line ${row.isIndent ? 'table-line--indent' : ''}">`;
          contentDOM += `<span>${row.title}</span>`;
          if (value) {
            contentDOM += `<span>${value}</span>`;
          }
          contentDOM += `</span>`;
        }

        contentDOM += `</div>`;
      }
      
      this.innerHTML = contentDOM;
    }

    setupToggle() {
      const panelId = this.dataset.panelId;
      if (!panelId) return;
      
      const toggle = document.querySelector(`.nutritional-unit-toggle[data-nutrition-panel="${panelId}"]`);
      if (!toggle) return;

      const buttons = toggle.querySelectorAll('.nutritional-unit-toggle__button');
      
      buttons.forEach(button => {
        button.addEventListener('click', (e) => {
          e.preventDefault();
          const unit = button.dataset.unit;
          
          // Update button states
          buttons.forEach(btn => {
            btn.classList.remove('active');
            btn.setAttribute('aria-pressed', 'false');
          });
          button.classList.add('active');
          button.setAttribute('aria-pressed', 'true');
          
          // Re-render table with new unit
          this.renderTable(unit);
        });
      });
    }
  }

  if ( typeof customElements.get('nutritional-info') == 'undefined' ) {
    customElements.define('nutritional-info', NutritionalInfo);
	}

}
